import { Checkbox, Divider, FormControl, FormControlLabel, IconButton, MenuItem, Radio, RadioGroup, Select, TextField } from '@mui/material'
import { FormItemStyled, FormStyled } from 'fwork.react.apptemplate'
import React, { useState } from 'react'
import { IoIosAdd } from "react-icons/io"
import { CtrolType, ICtrl, ICtrlList, ICtrlListItem, ICtrlParam, ICtrlRadio, ICtrlRadioDirection } from './models'
import DeleteIcon from '@mui/icons-material/Delete'
import { CommonUtils } from 'fwork-jsts-common/src'

const CtrlParamsPropsListItemComponent = (props: {
  style?: React.CSSProperties | undefined,
  items: ICtrlListItem[],
  onChange?: (items: ICtrlListItem[]) => void,
  onDeleteClickItem?: (ctrlItem: ICtrlListItem) => void
}) => {
  const items = props.items

  return <>
    <FormStyled className='rightContainerListItemComponent' style={{ ...props.style }}>
      <FormItemStyled fullWidth style={{ flexDirection: 'row', alignItems: 'center', padding: 0 }}>
        <h4 style={{ width: '100%' }}>Opções</h4>
        <IconButton style={{ width: 50, height: 50 }} aria-label="delete" onClick={() => {
          items?.push({
            uuid: CommonUtils.getNewUuid(),
            label: 'Escolha um título para a opção',
            value: `valor_da_opcao_${items.length + 1}`
          })

          if (props.onChange)
            props.onChange(items)
        }}>
          <IoIosAdd />
        </IconButton>
      </FormItemStyled>

      {items?.map((i, idx) => {
        return <React.Fragment key={idx}>
          <FormItemStyled fullWidth >
            <TextField

              label='Título'
              value={i.label || ''}
              onChange={(e) => {
                i.label = e.target.value
                if (props.onChange)
                  props.onChange(items)
              }}></TextField>
          </FormItemStyled>

          <FormItemStyled fullWidth style={{ flexDirection: 'row' }}>
            <TextField
              style={{ flexGrow: 1 }}
              label='Valor'
              value={i.value || ''}
              onChange={(e) => {
                i.value = e.target.value
                if (props.onChange)
                  props.onChange(items)
              }}></TextField>
            <IconButton style={{ width: 50, height: 50 }} aria-label="delete" onClick={() => {

              if (props.onDeleteClickItem)
                props.onDeleteClickItem(i)
            }}>
              <DeleteIcon />
            </IconButton>
          </FormItemStyled>
        </React.Fragment>
      })}
    </FormStyled>
  </>
}

export interface CtrlParamsPropsComponentProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  ctrl?: ICtrl,
  onChangeCtrl?: (ctrl: ICtrl) => void,
  onDelete?: (ctrl: ICtrl) => void,
}

export const CtrlParamsPropsComponent = (props: CtrlParamsPropsComponentProps) => {
  let { ctrl, onChangeCtrl, onDelete, ...rest } = props

  const [error, setError] = useState<string | undefined>()

  return ctrl ? <div {...rest} style={{ ...props.style, display: 'flex', flexDirection: 'column' }}>
    <FormStyled>
      <FormItemStyled fullWidth>
        <Select
          value={(ctrl as ICtrlParam)?.type}
          fullWidth
          onChange={e => {
            if (ctrl) {
              (ctrl as any).type = e.target.value

              if ([CtrolType.radio, CtrolType.select].includes(ctrl.type as any)) {
                (ctrl as ICtrlList).items = (ctrl as ICtrlList).items || []
              }

              if (props.onChangeCtrl)
                props.onChangeCtrl(ctrl)
            }
          }}
        >
          {Object.keys(CtrolType).map(i =>
            <MenuItem key={(CtrolType as any)[i]} value={(CtrolType as any)[i]}>{i}</MenuItem>)}
        </Select>
      </FormItemStyled>

      {[CtrolType.label, CtrolType.text, CtrolType.num, CtrolType.date, CtrolType.check, CtrolType.radio, CtrolType.select].includes(ctrl.type as any) ?
        <FormItemStyled fullWidth>
          <TextField
            label='Descrição'
            value={(ctrl as ICtrlParam)?.label || ''}
            onChange={(e) => {
              if (ctrl) {
                (ctrl as ICtrlParam).label = e.target.value

                if (props.onChangeCtrl)
                  props.onChangeCtrl(ctrl)
              }
            }}></TextField>
        </FormItemStyled> : <></>}

      {[CtrolType.text, CtrolType.num, CtrolType.date, CtrolType.check, CtrolType.radio, CtrolType.select].includes(ctrl.type as any) ? <>
        <FormItemStyled fullWidth>
          <TextField
            label='Parâmetro'
            value={(ctrl as ICtrlParam)?.paramName || ''}
            onChange={(e) => {
              if (ctrl) {
                (ctrl as ICtrlParam).paramName = e.target.value

                if (props.onChangeCtrl)
                  props.onChangeCtrl(ctrl)
              }
            }}></TextField>
        </FormItemStyled>

        <FormItemStyled fullWidth>
          <FormControlLabel
            control={
              <Checkbox
                checked={(ctrl as ICtrlParam).required}
                onChange={e => {
                  if (ctrl) {
                    (ctrl as ICtrlParam).required = !(ctrl as ICtrlParam).required
                    if (props.onChangeCtrl)
                      props.onChangeCtrl(ctrl)
                  }
                }} />
            }
            label={'Requerido'} />
        </FormItemStyled>

        {ctrl.type == CtrolType.radio ?
          <FormItemStyled fullWidth>
            <RadioGroup onChange={(e) => {
              if (ctrl) {
                (ctrl as ICtrlRadio).direction = Number(e.target.value)
                if (props.onChangeCtrl)
                  props.onChangeCtrl(ctrl)
              }
            }}>
              <FormControlLabel value={ICtrlRadioDirection.horizontal} control={<Radio />} label={'Horizontal'} />
              <FormControlLabel value={ICtrlRadioDirection.vertical} control={<Radio />} label={'Vertical'} />
            </RadioGroup>
          </FormItemStyled> : <></>}
      </> : <></>}
    </FormStyled>

    {[CtrolType.radio, CtrolType.select].includes(ctrl.type as any) ?
      <>
        <CtrlParamsPropsListItemComponent
          items={(ctrl as ICtrlList).items}
          onDeleteClickItem={(item) => {
            if ((ctrl as ICtrlList).items.length == 1) {
              setError('Deve existir pelo menos 1 item')
              return
            }

            if (ctrl) {
              (ctrl as ICtrlList).items = (ctrl as ICtrlList).items.filter(i => i.uuid != item.uuid)
              if (props.onChangeCtrl)
                props.onChangeCtrl(ctrl)
            }
          }}
          onChange={(items: ICtrlListItem[]) => {
            if ((ctrl as ICtrlList).items.length > 1) 
              setError(undefined)

            if (ctrl) {
              (ctrl as ICtrlList).items = items
              if (props.onChangeCtrl)
                props.onChangeCtrl(ctrl)
            }
          }} />
        {error && <label style={{ color: '#F44336', padding: '0 10px 10px 10px', fontSize: 12 }}>{error}</label>}
      </> :
      <></>}

    <Divider />

    <FormStyled>
      <FormItemStyled>
        <IconButton style={{ width: 50, height: 50, color: '#FF4500' }} aria-label="delete" onClick={() => {
          if (props.onDelete && ctrl)
            props.onDelete(ctrl)
        }}>
          <DeleteIcon />
        </IconButton>
      </FormItemStyled>
    </FormStyled>
  </div> : <></>
}